import { axiosInstance } from ".";

export const reportService = (state) => {
  return {
    async getUserMonthlyReport() {
      const response = await axiosInstance.get(
        `report/user-report-monthly-new-user`
      );

      return response?.data || [];
    },
    async getDeviceTempReport() {
      const response = await axiosInstance.get(
        `report/device-temp`
      );

      return response?.data || [];
    },
    async report(start_date, end_date, sale_spot, user) {
      const params = new URLSearchParams();
      params.append("start_date", start_date);
      params.append("end_date", end_date);
      if (sale_spot) params.append("sale_spot", sale_spot);
      if (user) params.append("user", user);
      const response = await axiosInstance.get(
        `report/product${params.toString() ? `?${params.toString()}` : ""}`
      );
      return response?.data || [];
    },
    async productSaleReportDate(start_date, end_date) {
      const params = new URLSearchParams();
      params.append("start_date", start_date);
      params.append("end_date", end_date);
      const response = await axiosInstance.get(
        `report/product-sale-report-date-and-user?${params.toString()}`
      );
      return response?.data || [];
    },

    async userRetentionReport(start_date, end_date) {
      const params = new URLSearchParams();
      params.append("start_date", start_date);
      params.append("end_date", end_date);
      const response = await axiosInstance.get(
        `report/user-retention-report?${params.toString()}`
      );
      return response?.data || [];
    },

    async productSaleReportSaleSpot(start_date, end_date) {
      const params = new URLSearchParams();
      params.append("start_date", start_date);
      params.append("end_date", end_date);
      const response = await axiosInstance.get(
        `report/product-sale-report-by-spot-16-to-16?${params.toString()}`
      );
      return response?.data || [];
    },
  };
};
